import { defineMessages } from 'react-intl';

export default defineMessages({
  select: {
    id: 'selectInput.select',
    defaultMessage: 'Select',
  },
});
